import { PAYPAL_INFO } from "@/feature-wallet/constants.mjs";
import type { PaymentMethodType } from "@/feature-wallet/models/any-payment-method.mjs";
import { devWarn } from "@/util/dev.mjs";

type MinimumPaymentMethod = {
  type: PaymentMethodType;
  cardLast4?: string;
} & (
  | { type: "card"; cardLast4: string }
  | { type: "paypal_account"; cardLast4?: unknown }
  | { type: "unknown"; cardLast4?: unknown }
);

export function getPaymentMethodTranslation(
  paymentMethod: MinimumPaymentMethod,
): Translation {
  if (paymentMethod.type === "card") {
    return [
      "common:wallet.cardLastFour",
      "•••• {{cardLast4}}",
      {
        cardLast4: paymentMethod.cardLast4,
      },
    ];
  }

  if (paymentMethod.type === "paypal_account") {
    return PAYPAL_INFO.localization;
  }

  devWarn("Cannot localize unknown payment methods", paymentMethod);

  return ["common:wallet.paymentType.unknown", "Unknown"];
}
